import { isRunningLocally } from "utils/Environment";
import type { IEnvironment } from "../../types/EnvironmentTypes";

let devRegistryURL = process.env.REACT_APP_DEV_REGISTRY_URL;
if (!devRegistryURL) {
  console.warn('The environment variable "REACT_APP_DEV_REGISTRY_URL" must be defined, using the default one.');
  devRegistryURL = "https://complete.pub.dev1.tfk.dev.fortisapi.games";
}

// Since we don't have a Registry for the Registry, that's basically how the Admin Panel should know where to make its requests.
// If an environment is provided, use its registryURL. Otherwise, fall back to the default behavior.
export const getRegistryURL = (environment?: IEnvironment) => {
  // we only care if it is staging or prod
  if (environment && environment.registryURL && environment.stage >= 8) {
    return environment.registryURL;
  }

  if (isRunningLocally()) {
    return "http://localhost:3001";
  } else {
    return devRegistryURL as string;
  }
};
